import { isDev } from './environment';

import { FRIENDS_CUP_PATHS } from '@/types/friendCup';

const SERVER_DEV = import.meta.env.VITE_SERVER_DEV;

export const SERVER = isDev ? SERVER_DEV : window.location.origin;
const actionUrl = '/grandt/mobileWM.html?_action';
let SERVER_AYUNDANTE = SERVER;
if (SERVER.indexOf('mobile.testgrandt.agea.com.ar') >= 0) {
  // ver si se puede dejar de publicar en mobile.testgrandt.agea.com.ar
  SERVER_AYUNDANTE = 'http://m-testgrandt-wf.agea.com.ar';
}

const SPRING_PATH = 'srv/spring';
const F5_PATH = 'f5/armado';
const BUILD_TEAM_F5_PATH = `${SERVER}/${SPRING_PATH}/${F5_PATH}`;
export const URLs = {
  VERSION_APP: `${SERVER}/version.txt`,
  REPORT_CRASH: `${actionUrl}=reportCrash`,
  LOGIN_AUTH0: `/grandt/auth0.html?_action=callback`,
  REFRESH_DATOS_INICIALES: `${actionUrl}=datos`,
  CHECK_NUEVA_PUBLICACION: '/grandt/publicacion.htm?_action=get',
  CHECK_LOGGED_IN: `/grandt/faq.html?_action=user`,
  FAQ_SUBMIT: `/grandt/faq.html?_action=post&accion=`,
  CONFIG_AUTH0: `/grandt/auth0.html?_action=configWM`,
  // LOGIN: `${actionUrl}=initMasDatos`,
  SESSION_INVALIDATE_DBG: `${actionUrl}=logout`,
  AUTH0_RECUPERAR_EMAIL: `/grandt/auth0.html?_action=recuperarEmail`,
  CAMISETA_ESCUDO_POR_ID: `${SERVER}/${SPRING_PATH}/camiseta/obtener-camisetas-por-ids`,
  REGISTRO: {
    LOAD: `${actionUrl}=datosReg`,
    SAVE: `${actionUrl}=grabarReg`,
  },
  NOMBRE_DE_EQUIPO: `/grandt/registracion.htm?_action=nombre-eq-utilizable`,
  BUSCAR_DTS: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/buscar-dts`,
  PARTIDOS: `${actionUrl}=datosGeografia&concepto=provincia`,
  LOCALIDADES: `${actionUrl}=datosGeografia&concepto=partido`,
  ESCUELAS_PRIMARIA: `${SERVER_AYUNDANTE}/escuelas/primaria/`,
  ESCUELAS_SECUNDARIA: `${SERVER_AYUNDANTE}/escuelas/secundaria/`,
  INVITAR_AMIGO: `${SERVER}/${SPRING_PATH}/invitaciones/invitar-amigo`,
  TORNEO_INVITAR_EMAIL: `${SERVER}/grandt/mobileWM.html`,
  SUGERIR_USUARIOS: `${SERVER}/grandt/mobileWM.html`,
  ARMA_EQUIPO_F11: {
    INIT: `${SERVER}/${SPRING_PATH}/arma-equipo/equipo-borrador`,
    GRABAR_BORRADOR: `${SERVER}/${SPRING_PATH}/arma-equipo/equipo-borrador`,
    CRITERIOS_RECOMENDADOR: `${SERVER}/${SPRING_PATH}/arma-equipo/criterios-recomendador`,
    CONFIRMAR: `${SERVER}/${SPRING_PATH}/arma-equipo/confirmar-equipo`,
    EQUIPO_CONFIRMADO: `${SERVER}/${SPRING_PATH}/arma-equipo/info-equipo-confirmado`,
    EDICION_ANTERIOR: `${SERVER}/${SPRING_PATH}/arma-equipo/equipo-edicion-anterior`,
  },
  ARMA_EQUIPO_F5: {
    INIT: `${BUILD_TEAM_F5_PATH}/init`,
    CONFIRMAR: `${BUILD_TEAM_F5_PATH}/confirmar-equipo`,
    AGREGAR_JUGADOR: `${BUILD_TEAM_F5_PATH}/agregar-jugador`,
    ELIMINAR_JUGADOR: `${BUILD_TEAM_F5_PATH}/quitar-jugador`,
    SELECCIONAR_ASEGURADO: `${BUILD_TEAM_F5_PATH}/asegurar-jugador`,
    SELECCIONAR_CAPITAN: `${BUILD_TEAM_F5_PATH}/cambiar-capitan`,
    INFO_EQUIPO_CONFIRMADO: `${BUILD_TEAM_F5_PATH}/info-equipo-confirmado`,
  },
  EQUIPO_11: {
    RANKING: `${SERVER}${actionUrl}=historico`,
    EQUIPO_ACTUAL: `${SERVER}${actionUrl}=equipoactual`,
    HACER_TRANFERENCIA: `${SERVER}${actionUrl}=transferencia`,
    HACER_CAMBIO: `${SERVER}${actionUrl}=cambio`,
    HACER_CAPITAN: `${SERVER}${actionUrl}=cambiarcapitan`,
  },
  EQUIPO_5: {
    INIT: `${SERVER}/${SPRING_PATH}/f5/mi-equipo/init`,
    HACER_TRANFERENCIA: `${SERVER}${actionUrl}=transferenciaf5`,
    HACER_CAPITAN: `${SERVER}${actionUrl}=cambiarcapitanf5`,
    HACER_ASEGURADO: `${SERVER}${actionUrl}=cambiarSeguroJugadorF5`,
    RANKING: `${SERVER}${actionUrl}=historicof5`,
  },
  MI_CUENTA: {
    PRODUCTOS_DISPONIBLES: `${SERVER}/${SPRING_PATH}/cuentas/productos-disponibles`,
    MONTOS: `${SERVER}/${SPRING_PATH}/cuentas/montos-carga`,
    TRX_PENDIENTES: `${SERVER}/${SPRING_PATH}/cuentas/trx-pendientes`,
    PAYU_SEND: `${SERVER}/${SPRING_PATH}/cuentas/prepare-payu-send`,
    FORM_PAGO: `${SERVER}/${SPRING_PATH}/cuentas/GWPAGOSMobileServlet`,
    INIT: `${SERVER}/${SPRING_PATH}/cuentas/init`,
    ASOCIAR_PIN: `${SERVER}/${SPRING_PATH}/cuentas/asociar-pin-existente?1=1`,
    TOKENIZADAS: `${SERVER}/${SPRING_PATH}/cuentas/tc-tokenizadas?1=1`,
    COMPRA_CON_SALDO: `${SERVER}/${SPRING_PATH}/cuentas/compra-con-saldo`,
    TRANSFERIR_SALDO_CONSULTA: `${SERVER}/${SPRING_PATH}/cuentas/transferir-saldo-consulta`,
    TRANSFERIR_SALDO_ENVIO: `${SERVER}/${SPRING_PATH}/cuentas/transferir-saldo-envio`,
    BUSQUEDA_MAPA: `${SERVER}/${SPRING_PATH}/cuentas/busqueda-mapa`,
    DETALLE_PAQUETE: `${SERVER}/${SPRING_PATH}/cuentas/detalle-paquete`,
    GANADOR_DEBO_PEDIR_CBU: `${SERVER}/grandt/miCuenta.html?_action=deboPedirDB`,
  },
  MEDALLERO_COUNT: `${actionUrl}=medalleroCount`,
  AYUDANTE: {
    DINAMICOS: `${SERVER_AYUNDANTE}/ayudante/tmpCentralRefuerzosDinamico.gdt`,
    ESTATICOS: `${SERVER_AYUNDANTE}/ayudante/tmpCentralRefuerzosEstatico.gdt`,
    PUNTAJES_ULTIMA_FECHA: `${SERVER_AYUNDANTE}/ayudante/fixture2.gdt`,
    HISTORICO_DEMENUZADO: `${SERVER}/${SPRING_PATH}/equipo/puntajes/f11/desmenuzado`,
    HISTORICO_DEMENUZADO_F5: `${SERVER}/${SPRING_PATH}/equipo/puntajes/f5/desmenuzado`,
    FICHAS_PARTIDOS_RECIENTES: `${SERVER}/${SPRING_PATH}/ayudante/partidos-recien-verificados`,
    FIXTURE: `${SERVER}/${SPRING_PATH}/ayudante/fixture-anterior-con-puntos`,
  },
  DASHBOARD: {
    RANKINGS: `${SERVER}/${SPRING_PATH}/dashboard/ranking`,
    SURVEY: `${SERVER}${actionUrl}=votarEncuesta`,
    INICIAR_TRIVIA: `${SERVER}/${SPRING_PATH}/trivias/init`,
    PARTICIPAR_TRIVIA: `${SERVER}/${SPRING_PATH}/trivias/participar`,
    OBTENER_PREGUNTA: `${SERVER}/${SPRING_PATH}/trivias/obtener-pregunta`,
    RESPONDER_PREGUNTA: `${SERVER}/${SPRING_PATH}/trivias/responder-pregunta`,
  },
  TORNEO_AMIGOS: {
    INIT: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/init?1=1`,
    LISTAR_TDAP: `${actionUrl}=listarTapsUsuario`,
    RECOMENDADOS: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/torneos-sugeridos`,
    POSTULARSE: `${SERVER}${actionUrl}=postularseTDA`,
    TRATAR_POSTULANTE: `${SERVER}${actionUrl}=tratarPostulanteTDA`,
    EXPULSAR_MIEMBRO: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/admin/expulsar`,
    CREAR_TORNEO: `${SERVER}${actionUrl}=crearTDA`,
    VER_TORNEO: `${SERVER}${actionUrl}=torneoamigos`,
    VER_TORNEO_F5: `${SERVER}${actionUrl}=torneoamigosf5`,
    VER_ADMIN: `${SERVER}${actionUrl}=adminTDA`,
    FECHAS_DISPONIBLES: `${SERVER}${actionUrl}=fechasDisponiblesTDA`,
    ANTERIORES: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/anteriores`,
    REACTIVAR: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/anteriores/reactivar`,
    VALIDAR_NOMBRE: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/validar-nombre`,
    SUGUERIR_PINES: `${actionUrl}=sugerirPinesTDAVIP`,
    VALIDAR_PINES: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/validar-pines`,
    CONVERTIR_TDA: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/convertir-torneo-vip`,
    OBTENER_DATOS_BANCARIOS: `${SERVER}${actionUrl}=obtenerDatosBancarios`,
    GUARDAR_DATOS_BANCARIOS: `${SERVER}${actionUrl}=guardarDatosBancarios`,
    OBTENER_POSTS_CHAT: `${SERVER}${actionUrl}=vermuro`,
    ENVIAR_POSTS_CHAT: `${SERVER}${actionUrl}=enviarmensaje`,
    PORTADA_UPLOAD: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/portada/upload?1=1`,
    PORTADA_DELETE: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/portada/eliminar?1=1`,
    PORTADA_SELECT_PREDEFINED: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/portada/elegir-predefinida?1=1`,
    MODIFICAR_FECHA: `${SERVER}${actionUrl}=actualizarFechaTDA`,
    MODIFICAR_NOMBRE: `${SERVER}${actionUrl}=renombrarTA`,
    AUTOCOMPLETE_NOMBRE_TDA:
      'grandt/autocomplete.htm?_action=sugerir&a=a&cls=TA_nombreTA',
    AUTOCOMPLETE_APELLIDO_DT:
      'grandt/autocomplete.htm?_action=sugerir&a=a&cls=TA_DUENIO_APE',
    LISTA_TORNEOS: `${actionUrl}=listarTDAs`,
    INVITAR_POR_ID: `${SERVER}/grandt/mobileWM.html`,
    DATOS_BASICOS: `${SERVER}/${SPRING_PATH}/torneos-de-amigos/datos-basicos`,
    ACEPTAR_TODOS_POSTULANTES: `${SERVER}${actionUrl}=aceptarTodosTDA`,
  },
  COPA_AMIGOS: {
    INIT: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.init}`,
    TOP10: `${SERVER_AYUNDANTE}/ganadores`,
    CREAR: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.crearGrupoCopaAmigos}`,
    CAMBIAR_NOMBRE: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.cambiarNombreGrupoCopaAmigos}`,
    GRUPOS_SUGERIDOS: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.sugerirGruposCopaAmigos}`,
    ENVIAR_SOLICITUD_GRUPO: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.suscribirse}`,
    BUSCAR_GRUPO: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.buscarGrupos}`,
    BUSCAR_DTS: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.buscarDTs}`,
    TRATAR_POSTULANTE: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.tratarPostulacion}`,
    EXPULSAR_MIEMBRO: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.expulsarParticipanteGCA}`,
    VALIDAR_NOMBRE: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.validarNombreGrupo}`,
    INVITAR_AMIGOS_MAIL: `${actionUrl}=invitarAmigosGCA`,
    INVITAR_DT: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.invitarDT}`,
    SUGERIR_USUARIOS: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.sugerirUsuarios}`,
    VER_COPA_AMIGOS: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.verGrupo}`,
    DATOS_BASICOS: `${SERVER}/${SPRING_PATH}/${FRIENDS_CUP_PATHS.datosBasicos}`,
  },
  MINILIGAS: {
    INIT: `${SERVER}${actionUrl}=miniLigaInit`,
    CREAR: `${SERVER}${actionUrl}=crearML&nombre=`,
    VER_MINILIGA: `${SERVER}${actionUrl}=verMiniLiga`,
    VER_RIVAL: `${SERVER}${actionUrl}=miniLigaMostrarEquipos`,
    // desenlace
    INIT_DESENLACE: `${SERVER}${actionUrl}=miniLigaInitDesenlace`,
    GANADORES_EMERGENCIA: `${SERVER}/ganadores/ganadores_desenlace_ml_`,
    GANADORES: `${SERVER}/${SPRING_PATH}/miniligas/desenlace/ganadores`,

    LISTA_PARTICIPANDO: `${SERVER}${actionUrl}=listarMiniLigas`,
    LISTA_EDICION_PASADA: `${SERVER}${actionUrl}=miniligasAnteriores`,
    TRATAR_POSTULANTE: `${SERVER}${actionUrl}=miniligaTratarPostulante`,
    // trae la lista de "Te invitaron a participar"
    // ademas trae la lista de "Esperando aceptación"
    LISTA_INVIT_PENDIENTES: `${SERVER}${actionUrl}=listarMiniLigasPendientes`,
    LISTA_RECOMENDADOS: `${SERVER}${actionUrl}=sugerirUsuariosML`,
    // corresponde al listado lateral de "Recomendadas"
    LISTA_SUGERIDOS: `${SERVER}${actionUrl}=sugerirML`,
    ENVIAR_SOLICITUD_MINILIGA: `${SERVER}${actionUrl}=inscribir`,
    VALIDAR_NOMBRE: `${SERVER}/${SPRING_PATH}/miniligas/validar-nombre`,
    VER: `${SERVER}${actionUrl}=verMiniLiga`,
    LISTAR_PARTICIPANTES: `${SERVER}${actionUrl}=partML`,
    DATOS_BASICOS: `${SERVER}/${SPRING_PATH}/miniligas/datos-basicos`,
    EXPULSAR_MIEMBRO: `${SERVER}${actionUrl}=expulsar`,
    INVITAR_DT_POR_ID: `${SERVER}${actionUrl}=invitarDTaML`,
    // BUSCAR_MINILIGA: `${SERVER}/${SPRING_PATH}/miniligas/buscar-miniligas`,
    BUSCAR_MINILIGA: `${SERVER}${actionUrl}=buscarML`,
    REACTIVAR: `${SERVER}${actionUrl}=grabarMLAnterior`,
    AUTOCOMPLETE_NOMBRE_ML:
      'grandt/autocomplete.htm?_action=sugerir&a=a&cls=ML_nombreML',
    AUTOCOMPLETE_APELLIDO_MLDT:
      'grandt/autocomplete.htm?_action=sugerir&a=a&cls=ML_DUENIO_APE',
    BUSCAR_DTS: `${SERVER}/${SPRING_PATH}/miniligas/admin/buscar-dts`,
    INVITAR_POR_ID: `${SERVER}${actionUrl}=invitarDTaML`,
    INVITAR_EMAIL: `${SERVER}${actionUrl}=invitarMLMail`,
    ENVIAR_MENSAJE_CHAT: `${SERVER}/${SPRING_PATH}/miniligas/chat/guardar-mensaje`,
    OBTENER_MENSAJES_CHAT: `${SERVER}/${SPRING_PATH}/miniligas/chat/obtener-mensajes`,
    INVITAR_TKRED: `${SERVER}/${SPRING_PATH}/invitaciones/accion-post-login`,
  },
  TORNEO_AMIGOS_PREMIOS: {
    LISTA_TAP_USUARIO: `${SERVER}${actionUrl}=listarTapsUsuario`,
    DATOS_POPUP_INSCRIPCION: `${SERVER}${actionUrl}=datosPopupInscripcion`,
    TAP_INSCRIPCION: `${SERVER}${actionUrl}=inscribirse`,
    OBTENER_DATOS_BANCARIOS: `${SERVER}${actionUrl}=obtenerDatosBancarios`,
    VER_TAP: `${SERVER}${actionUrl}=verTap`,
    GUARDAR_DATOS_BANCARIOS: `${SERVER}${actionUrl}=guardarDatosBancarios`,
  },
  FECHA_DE_ORO: {
    INFO_USUARIO_ORO: `${SERVER}${actionUrl}=infoUsuarioFOro`,
    DATOS_POPUP_INSCRIPCION: `${SERVER}${actionUrl}=datosPopupInscripcionFOro`,
    INSCRIPCION: `${SERVER}${actionUrl}=inscrFOro`,
    VER: `${SERVER}${actionUrl}=verFOro`,
  },
  EDITAR_CUENTA: {
    DIPLOMAS: `${SERVER}/${SPRING_PATH}/diplomas/listado`,
    CAMPANIAS: `${SERVER}/${SPRING_PATH}/historico/campanias-init`,
    GET_TSHIRT_AND_SHIELD: `${SERVER}/${SPRING_PATH}/camiseta/obtener-camiseta-escudo-init`,
    POST_SHIELD: `${SERVER}/${SPRING_PATH}/camiseta/grabar-escudo`,
    SAVE_TSHIRT: `${SERVER}${actionUrl}=grabarCamiseta`,
    SAVE_PROFILE_PIC: `${SERVER}${actionUrl}=uploadFotoPerfil`,
  },
  RANKING_GENERAL_F5: `${SERVER}/ganadores/topGral_f5_`,
  RANKING_FECHA_F5: `${SERVER}/ganadores/topFecha_f5_`,
  RANKING_GENERAL_F11: `${SERVER}/ganadores/topGral_`,
  RANKING_FECHA_F11: `${SERVER}/ganadores/topFecha_`,

  RANKING_INIT_PROVINCIA: `${SERVER}/grandt/mobileWM.html?_action=rnkProvinciasInit`,
  RANKING_PROVINCIAS: `${SERVER}/grandt/mobileWM.html?_action=rnkProvinciasDatosTopN`,

  RANKING_LOCALIDAD: `${SERVER}/grandt/mobileWM.html?_action=rnkLocalidadDatosTopN`,
  RANKING_CALIFICACIONES_HISTORICAS: `${SERVER}/${SPRING_PATH}/ranking-ganadores/calificaciones-historicas`,
  RANKING_EQUIPO_GANADOR: `${SERVER}/ganadores/equipoganador_fecha_`,
  RANKING_EQUIPO_GANADOR_GENERAL: `${SERVER}/ganadores/equipoganador_general_`,
  RANKING_EQUIPO_GANADOR_F5_FECHA: `${SERVER}/ganadores/equipoganador_fecha_f5_`,
  RANKING_EQUIPO_GANADOR_F5_GENERAL: `${SERVER}/ganadores/equipoganador_general_f5_`,
  RANKING_INIT: `${SERVER}/${SPRING_PATH}/ranking-ganadores/init-rankings`,

  PROFILE: {
    PERSONAL_DATA: `${SERVER}${actionUrl}=editarDatos`,
    TEAM_NAME: `${SERVER}/${SPRING_PATH}/cambiar-nombre-equipo`,
    SEND_EMAIL_TO_CHANGE_PASSWORD: `${SERVER}/grandt/auth0.html?_action=enviarPasswordReset`,
  },
  TORNEO_ESCUELA: {
    TDE_INIT: `${SERVER}${actionUrl}=tdeinit`,
    TDE_RANKING_DATOS: `${SERVER}${actionUrl}=tdedatos`,
    TDE_MI_ESCUELA: `${SERVER}${actionUrl}=tdemiescuela`,
  },
  MEDALLERO: {
    INIT: `${SERVER}${actionUrl}=medalleroInit`,
    TOP50: `${SERVER}/ganadores/ranking_medallero_`,
    SEARCH: `${SERVER}/${SPRING_PATH}/medallero/buscar`,
  },
  PUSH_NOTIFICATIONS: {
    AUTHORIZE: `${SERVER}${actionUrl}=tokenFCM`,
    DEBUG_COMPLETAR_LOGS: `${SERVER}/${SPRING_PATH}/fcm/debug-usuario`,
  },
  DESAFIOUNOAUNO: {
    RESULTADOS_FECHA: `${SERVER}${actionUrl}=resultFechaDesafio`,
    BUSCAR_USUARIOS: `${SERVER}/${SPRING_PATH}/desafios/busqueda-2025`,
    INIT: `${SERVER}/${SPRING_PATH}/desafios/init`,
    ACEPTAR_TODOS: `${SERVER}${actionUrl}=aceptarTodosDesafio`,
    VOLVER_A_DESAFIAR_TODOS: `${SERVER}/${SPRING_PATH}/desafios/volver-a-desafiar-todos`,
    TRATAR_DESAFIO: `${SERVER}${actionUrl}=tratarDesafio`,
    SUGERIR_USUARIOS: `${SERVER}${actionUrl}=sugerirDTsWM`,
    // SUGERIR_USUARIOS: `${SERVER}/${SPRING_PATH}/desafios/sugerir-usuarios`,
    DESAFIAR_USUARIO: `${SERVER}${actionUrl}=desafiarUsuario`,
    RESULTADO_FECHA_DESAFIO: `${SERVER}${actionUrl}=resultFechaDesafio`,
  },
  // GANADOR_GUARDAR_CBU: `${SERVER}${actionUrl}=guardarDatosBancarios`,
  // GANADOR_OBTENER_CBU: `${SERVER}${actionUrl}=obtenerDatosBancarios`,
  ALERTAS_WEB: {
    LISTADO: `${SERVER}/${SPRING_PATH}/alertas-web/listado`,
    MARCAR_LEIDAS: `${SERVER}/${SPRING_PATH}/alertas-web/marcar-alertas-leidas`,
  },
};
